<template>
  <v-card v-if="filters">
    <v-toolbar color="primary" dark>
      <v-toolbar-title>Filter Tasks</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="resetFilters" color="orange" dark>Reset Filters</v-btn>
      <v-btn :disabled="showTotalSelectionError" @click="saveFilters" color="success" dark>Save Filters</v-btn>
      <v-btn @click="$emit('cancel-dialog')" icon flat dark><v-icon>cancel</v-icon></v-btn>
    </v-toolbar>
    <v-container text-xs-center>
      <v-layout>
        <v-checkbox v-if="currentView !== 'construction' && currentView !== 'preConstruction'" v-model="filters.showOnlyMyTasks" label="Show Only My Tasks"></v-checkbox>
        <v-checkbox v-if="currentView === 'construction' || currentView === 'preConstruction'" v-model="filters.showOnlyMyProjects" label="Show Only My Projects"></v-checkbox>
        <v-checkbox v-if="currentView !== 'construction' && currentView !== 'preConstruction'" v-model="filters.filterDoubleBooked" label="Double Booked Vendors"></v-checkbox>
        <v-checkbox v-if="currentView === 'construction' || currentView === 'preConstruction'" v-model="filters.includeCompletedProjects" label="Show Completed Projects"></v-checkbox>
        <!-- Users By Project Filter -->
        <v-flex xs6>
          <v-autocomplete outline v-model="filters.filterUserProjects" color="primary" :items="userList" label="Filter by User Assigned Projects" chips multiple deletable-chips />
        </v-flex>
      </v-layout>
      <v-alert :value="showTotalSelectionError" type="error">You can only add up to 10 multiple selected items per filter</v-alert>
      <v-layout row wrap>
        <!-- Projects Filter -->
        <v-flex xs6 class="pr-3">
          <v-autocomplete outline v-model="filters.filterProjects" color="primary" :items="projectList" label="Filter by Projects" chips multiple deletable-chips />
        </v-flex>
        <!-- Project % Filter -->
        <v-flex xs6 class="pl-3">
          <div style="border: 2px solid grey; border-radius: 4px;" class="pt-2 px-2">
            <v-layout>
              <div class="v-label">Filter by Project Completion %</div>
            </v-layout>
            <v-layout row>
              <v-flex shrink xs2>
              <v-text-field v-model="filters.filterPCTofProject[0]" class="mt-0 text-xs-center" hide-details single-line type="number"></v-text-field>
              </v-flex>
              <v-flex xs8 px-3>
                <v-range-slider v-model="filters.filterPCTofProject" :max="100" :min="0" :step="5" height="25px"></v-range-slider>
              </v-flex>
              <v-flex shrink xs2>
                <v-text-field v-model="filters.filterPCTofProject[1]" class="mt-0 text-xs-center" hide-details single-line type="number"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!-- Projects Types Filter -->
        <v-flex xs6 class="pr-3">
          <v-autocomplete :disabled="currentView === 'construction' || currentView === 'preConstruction'" outline v-model="filters.filterProjectTypes" color="primary" :items="projectTypes" label="Filter by Project Type" />
        </v-flex>
        <!-- Projects Phases Filter -->
        <v-flex xs6 class="pl-3">
          <v-autocomplete outline v-model="filters.filterProjectPhases" color="primary" :items="projectPhases" label="Filter by Project Phase" clearable />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!-- Tasks Filter -->
        <v-flex xs6 class="pr-3">
          <v-autocomplete outline v-model="filters.filterTasks" color="primary" :items="taskList" label="Filter by Tasks" chips multiple deletable-chips />
        </v-flex>
        <!-- Task Status Filter -->
        <v-flex xs6 class="pl-3">
          <v-autocomplete outline v-model="filters.filterTaskStatus" color="primary" :items="taskStatusList" label="Filter by Task Status" chips multiple deletable-chips />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!-- Vendors Types Filter -->
        <v-flex xs6 class="pr-3">
          <v-autocomplete outline v-model="filters.filterVendors" color="primary" :items="vendorList" label="Filter by Vendors" chips multiple deletable-chips />
        </v-flex>
        <!-- Vendor Types Filter -->
        <v-flex xs6 class="pl-3">
          <v-autocomplete outline v-model="filters.filterVendorTypes" color="primary" :items="vendorTypeList" label="Filter by Vendor Types" chips multiple deletable-chips />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!-- Builders Types Filter -->
        <v-flex xs6 class="pr-3">
          <v-autocomplete outline v-model="filters.filterBuilders" color="primary" :items="builderList" label="Filter by Builders" chips multiple deletable-chips />
        </v-flex>
        <!-- Users By Task Filter -->
        <v-flex xs6 class="pl-3">
          <v-autocomplete outline v-model="filters.filterUsers" color="primary" :items="userList" label="Filter by User Assigned Tasks" chips multiple deletable-chips />
        </v-flex>
      </v-layout>
      <!-- Filter by Time Range -->
      <v-layout row wrap>
        <!-- Tasks Filter -->
        <v-flex xs6 class="pr-3">
          <v-select outline v-model="filters.filterDates" color="primary" :items="filterDateOptions" label="Filter by Time Range" />
        </v-flex>
        <template v-if="filters.filterDates === 'Custom Date Range'">
          <v-flex xs1>
            <v-btn @click="showStartDateFilter = true" flat icon color="grey darken-2"><v-icon large>event</v-icon></v-btn>
          </v-flex>
          <v-flex xs2>
            <v-text-field @click="showStartDateFilter = true" v-model="filters.filterDateStart" label="Start Date" readonly></v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-btn @click="showEndDateFilter = true" flat icon color="grey darken-2"><v-icon large>event</v-icon></v-btn>
          </v-flex>
          <v-flex xs2>
            <v-text-field @click="showEndDateFilter = true" v-model="filters.filterDateEnd" label="End Date" readonly></v-text-field>
          </v-flex>
        </template>
      </v-layout>
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn :disabled="showTotalSelectionError" @click="saveFilters" color="success" dark>Save Filters</v-btn>
      </v-layout>
      <v-dialog v-model="showStartDateFilter" width="290px">
        <v-date-picker v-model="filters.filterDateStart" @input="showStartDateFilter = false"></v-date-picker>
      </v-dialog>
      <v-dialog v-model="showEndDateFilter" width="290px">
        <v-date-picker v-model="filters.filterDateEnd" @input="showEndDateFilter = false"></v-date-picker>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['currentView'],
  data () {
    return {
      filterDateOptions: [ 'Any Time', '12 Month Range', '6 Month Range', 'This Month', 'This Year', 'Next 3 Months', 'Next 6 Months', 'Next 12 Months', 'Last 6 Months', 'Last 12 Months', 'Custom Date Range' ],
      showStartDateFilter: false,
      showEndDateFilter: false
    }
  },
  created () {
    if (!this.$store.getters.allTasksList || this.$store.getters.allTasksList.length < 1) {
      this.$store.dispatch('getAllTasksList')
    }
  },
  mounted () {
    console.log('Current View: ', this.currentView)
  },
  computed: {
    filters () {
      return this.$store.getters.taskFilters[this.currentView]
    },
    projectTypes () {
      return ['Pre-Construction', 'Construction', 'Completed']
    },
    projectPhases () {
      return this.$store.getters.projectPhases
    },
    showTotalSelectionError () {
      if ((this.filters.filterProjects && this.filters.filterProjects.length > 10) ||
      (this.filters.filterTasks && this.filters.filterTasks.length > 10) ||
      (this.filters.filterTaskStatus && this.filters.filterTaskStatus.length > 10) ||
      (this.filters.filterVendors && this.filters.filterVendors.length > 10) ||
      (this.filters.filterVendorTypes && this.filters.filterVendorTypes.length > 10) ||
      (this.filters.filterBuilders && this.filters.filterBuilders.length > 10) ||
      (this.filters.filterUsers && this.filters.filterUsers.length > 10)) {
        return true
      }
    },
    builderList () {
      return _.sortBy(this.$store.getters.builderList.map(builder => ({ text: builder.company_name, value: builder.company_name })), 'text')
    },
    vendorTypeList () {
      let vendorTypes = []
      let allTypes = this.$store.getters.vendorList.map(vendor => vendor.vendor_type)
      allTypes.forEach(type => {
        vendorTypes.push(type[0])
      })
      return _.uniq(vendorTypes).sort()
    },
    vendorList () {
      return _.sortBy(this.$store.getters.vendorList.map(vendor => ({ text: vendor.company_name, value: vendor.id })), 'text')
    },
    taskList () {
      return this.$store.getters.allTasksList.sort()
    },
    taskStatusList () {
      return ['Not Started', 'Started', 'On Hold', 'Flagged', 'Completed']
    },
    userList () {
      return _.sortBy(this.$store.getters.userList.map(user => ({ text: user.first_name + ' ' + user.last_name, value: user.id })), 'text')
    },
    projectList () {
      return _.sortBy(this.$store.getters.projectSearch.map(project => ({ text: project.name, value: project.id })), 'text')
    }
  },
  methods: {
    saveFilters () {
      this.$store.dispatch('saveUserFilters', { [this.currentView]: this.filters })
      this.$emit('execute-filters')
    },
    resetFilters () {
      this.$store.dispatch('loadDefaultFilters')
      this.$store.dispatch('saveUserFilters', { [this.currentView]: this.$store.getters.defaultFilters[this.currentView] })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/FilterDialog.vue